/**
 * Calculate weekly pay with overtime (1.5x after 40 hours).
 * Returns { regularHours, overtimeHours, regularPay, overtimePay, totalPay }
 */
export function calculateOvertimePay(totalWeeklyHours: number, hourlyRate: number) {
  const OVERTIME_THRESHOLD = 40;
  const OVERTIME_MULTIPLIER = 1.5;

  const regularHours = Math.min(totalWeeklyHours, OVERTIME_THRESHOLD);
  const overtimeHours = Math.max(0, totalWeeklyHours - OVERTIME_THRESHOLD);
  const regularPay = regularHours * hourlyRate;
  const overtimePay = overtimeHours * hourlyRate * OVERTIME_MULTIPLIER;
  const totalPay = regularPay + overtimePay;

  return { regularHours, overtimeHours, regularPay, overtimePay, totalPay };
}
